import React from 'react';
import PropTypes from 'prop-types';
import { isType, flattenChildren } from '../../../../utils/react-children-utils/react-children-utils';
import { getValidationSummary, initFieldIsValids } from '../../../../utils/form-utils';
import ControlP from '../../../atoms/control/ControlP';
import SubmitButton from '../../../atoms/submit-button/index.ts';
import styles from './styles.scss';
import InputContainer from '../../../atoms/inputs/input-container';
import SquareOnlyFilePicker from '../../../molecules/filepickers/square-only-file-picker/SquareOnlyFilePicker';

class CharityManageAccountForm extends React.Component {
    constructor(props) {
        super(props);

        this.setFieldState = this.setFieldState.bind(this);
        this.handleLogoUpload = this.handleLogoUpload.bind(this);
        this.handleFaviconUpload = this.handleFaviconUpload.bind(this);
        this.getControl = this.getControl.bind(this);

        const fieldIsValids = initFieldIsValids(
            flattenChildren(props.children)
                .filter((c) => isType(c, 'ControlP')),
        );

        this.state = {
            fieldIsValids,
        };
    }

    handleLogoUpload(inputContainer) {
        const children = flattenChildren(inputContainer.props.children);
        const { name } = inputContainer.props;

        const filepicker = children
            .find((c) => isType(c, 'S3FilePicker'));
        const otherEls = children.filter((c) => !isType(c, 'input'))
            .map((c) => React.cloneElement(c, { key: `${name}-${c.type?.name ?? c.type}` }));

        const newFilePicker = React.cloneElement(
            filepicker,
            {
                key: name,
                maxsize: 2,
                optional: true,
                extensions: ['.png', '.jpg', '.jpeg'],
                passerror: (error) => { this.setFieldState(inputContainer.props.name, error); },
                round: true,
            },
        );

        return [newFilePicker].concat(otherEls);
    }

    handleFaviconUpload(inputContainer) {
        const children = flattenChildren(inputContainer.props.children);
        const { name } = inputContainer.props;
        const otherEls = children.filter((c) => !isType(c, 'input'))
            .map((c) => React.cloneElement(c, { key: `${name}-${c.type?.name ?? c.type}` }));

        const filepicker = children
            .find((c) => isType(c, 'S3FilePicker'));
        const newFilePicker = (
            <SquareOnlyFilePicker
                {...filepicker.props}
                {...{
                    round: true,
                    optional: true,
                    extensions: ['.png', '.jpg', '.jpeg'],
                    maxsize: 2,
                    key: name,
                    passerror: (error) => { this.setFieldState(inputContainer.props.name, error); },
                }}
            />
        );

        return [newFilePicker].concat(otherEls);
    }

    getControl(control) {
        const currentControl = control;

        const controlChildren = flattenChildren(currentControl.props.children);

        const label = controlChildren.find((c) => isType(c, 'InputLabel'));
        const inputContainer = controlChildren.find((c) => isType(c, 'InputContainer'));

        let newInputs = inputContainer.props.children;
        const passError = this.setFieldState;

        // handle special inputs where we need to pass in more props

        if (inputContainer.props.name === 'charitylogourl') {
            newInputs = this.handleLogoUpload(inputContainer);
        }
        if (inputContainer.props.name === 'faviconurl') {
            newInputs = this.handleFaviconUpload(inputContainer);
        }

        return (
            <ControlP key={`${inputContainer.props.name}-control`}>
                {label}
                <InputContainer
                    passerror={passError}
                    name={inputContainer.props.name}
                    displayname={inputContainer.props.displayname}
                    required={inputContainer.props.required}
                >
                    {newInputs}
                </InputContainer>
            </ControlP>
        );
    }

    setFieldState(fieldName, error) {
        const { fieldIsValids } = this.state;

        const newFields = fieldIsValids;
        newFields[fieldName] = !error;

        this.setState(() => ({
            fieldIsValids: newFields,
        }));
    }

    render() {
        const { children } = this.props;
        const { fieldIsValids } = this.state;

        const formError = children.find((c) => getValidationSummary(c));

        const invalid = Object.values(fieldIsValids).filter((c) => !c).length > 0;

        const controls = flattenChildren(children)
            .filter((c) => isType(c, 'ControlP'))
            .map((c) => this.getControl(c));

        return (

            <div className={styles['charity-manage-account-form']}>
                {formError}
                <form method="post">
                    {controls}
                    <div className="columns is-centered">
                        <div className="column is-narrow">
                            <div className="control mt-4 has-text-centered">
                                <SubmitButton isdisabled={invalid} label="Save" name="charity-manage-account-submit" />
                            </div>
                        </div>
                    </div>
                </form>
            </div>

        );
    }
}

CharityManageAccountForm.propTypes = {
    children: PropTypes.node.isRequired,
};

CharityManageAccountForm.defaultProps = {
};

export default CharityManageAccountForm;
